import type angular from "angular"

import type AuthService from "../../services/auth/auth.service"
import type BootstrapService from "../../services/bootstrap/bootstrap.service"
import type BreadcrumbService from "../../services/breadcrumb-service/breadcrumb.service"

/**
 * Redirects once bootstrap is ready
 */
export class LoadingController {
  /**
   * @ngInject
   */
  constructor(
    $timeout: angular.ITimeoutService,
    AuthService: AuthService,
    BootstrapService: BootstrapService,
    BreadcrumbService: BreadcrumbService,
  ) {
    if (BootstrapService.ready) {
      $timeout().then(() => {
        if (AuthService.isLoggedIn) {
          BreadcrumbService.go("root.account.home")
        } else {
          BreadcrumbService.go("root.login")
        }
      })
    }
  }
}
